// assets
import { FileProtectOutlined,CarOutlined,FieldTimeOutlined, EditFilled, QuestionCircleOutlined} from '@ant-design/icons';

// icons<FieldTimeOutlined />
const icons = {
  FileProtectOutlined,
  CarOutlined,
  FieldTimeOutlined,
  EditFilled,
  QuestionCircleOutlined        
};

// ==============================|| MENU ITEMS - Query ||============================== //

const query= {
  id: 'group-query',
  title: 'Query',
  type: 'collapse',
  icon: icons.QuestionCircleOutlined,
  children: [
   
    {
      id: 'CustomerComplaint',
      title: 'Customer Complaint',
      type: 'item',
      url: '/request-update',
      icon: icons.EditFilled,
      breadcrumbs: false
    }
  ]
};

export default query;
